module.exports = __webpack_public_path__ + "img/De_train.56dbd02b.png";